import { useQuery } from '@apollo/client';

import Goal from '@components/Goal';
import HandleQuery from '@components/HandleQuery';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import useSubscribeToJourney from '@hooks/subscriptions/useSubscribeToJourney';
import {
  GetJourneyWithPlanDocument,
  GetJourneyWithPlanQuery,
  GetJourneyWithPlanQueryVariables
} from '@typing/Generated';

type Props = {
  goalId: string;
  journeyId: string;
};

const ExpertJourneyGoalPage = ({ goalId, journeyId }: Props) => {
  const getJourneyQuery = useQuery<GetJourneyWithPlanQuery, GetJourneyWithPlanQueryVariables>(
    GetJourneyWithPlanDocument,
    {
      variables: { id: journeyId }
    }
  );

  useSubscribeToJourney(journeyId, () => {
    getJourneyQuery.refetch();
  });

  const goal = getJourneyQuery.data?.journey.goals.find(goal => goal.id === goalId);

  if (!goal) {
    return <></>;
  }

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.goalTemplate.show" journeyId={journeyId}>
      <HandleQuery query={getJourneyQuery}>
        {journeyData => <Goal goal={goal} journey={journeyData.journey} />}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyGoalPage;
